module.exports = __webpack_public_path__ + "fonts/Flaticon.8f8135c4.woff2";